import styled from 'styled-components'
import modalLogInBackground01 from 'shared/assets/images/modalLogInBackground01.png'
import modalLogInBackground02 from 'shared/assets/images/modalLogInBackground02.png'

export const StyledKingdomNoBlazonContainer = styled.div`
    width: 100%;
    max-width: 360px;
    padding: 20px;
    margin: 0 auto;
    box-sizing: border-box;
`
export const StyledCoverBackground = styled.div`
    background-image: url(${modalLogInBackground01}),
        url(${modalLogInBackground02});
    background-repeat: no-repeat, no-repeat;
    background-position: right 40px bottom, right top;
    background-size: auto calc(85% - 20px), auto 100%;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`
export const StyledCloseButtonContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`
export const StyledBody = styled.div`
    padding-top: 10px;
    margin: 20px;
    text-align: center;
    display: flex;
    gap: 16px;
    flex-direction: column;
    align-items: center;
`
export const StyledButtonContainer = styled.div`
    width: 100%;
    margin: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 280px;
`
